/* eslint-disable class-methods-use-this */
/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.formParent = this.closest('product-form');
      this.form = this.formParent.querySelector('form') || null;
      this.formType = this.formParent.dataset.format || null;
      this.variant_json = this.querySelector('[data-variantJSON]');

      this.container = this.formType === 'product-card' ? this.closest('[data-product-card]') : this.closest('[data-product-container]');
    }

    connectedCallback() {
      const colorSwatchContainer = this.querySelector('.color-swatch');
      if(colorSwatchContainer){
        const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
        colorSwatches.forEach(swatch => {
          const colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
          const swatchStyle = Utility.getSwatchStyle(colorHandle);
          swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
        });
      }

      // Set initial variant and handle wholesale only
      this.setCurrentVariant();
      this.handleWholesaleOnly();

      this.addEventListener('change', (evt) => {
        const target = this.getInputForEventTarget(evt.target);
        eventBus.publish(PUB_SUB_EVENTS.optionChange, {
          data: {
            target,
            selectedOptionsId: this.optionValues,
          }
        });
        this.onVariantChange();
      });
      // if (this.formType === 'product-page') this.onVariantChange('load');
      // if (this.formType === 'product-page') 
      this.disableUnavailableOptions();

      if(typeof this.formParent?.updateProductDetails == 'function'){
        this.formParent.updateProductDetails(this.container, this.currentVariant);
      }

    }

    handleWholesaleOnly() {
      const isWholesaleOnly = this.currentVariant?.metafields?.wholesale_only === true;
      
      // Cache DOM queries to avoid repeated lookups
      const elements = {
        qtyContainer: this.container.querySelector('[data-qty-container]'),
        buyButtonForm: this.container.querySelector('form[data-type="add-to-cart-form"]'),
        distributorLink: this.container.querySelector('[data-distributor-link]'),
        distributorLinkText: this.container.querySelector('.data-distributor-link')
      };

      // Define visibility states for wholesale vs regular variants
      const visibilityStates = {
        wholesale: {
          qtyContainer: 'hide',
          buyButtonForm: 'hide', 
          distributorLink: 'show',
          distributorLinkText: 'hide'
        },
        regular: {
          qtyContainer: 'show',
          buyButtonForm: 'show',
          distributorLink: 'hide',
          distributorLinkText: 'show'
        }
      };

      const currentState = isWholesaleOnly ? visibilityStates.wholesale : visibilityStates.regular;

      // Apply visibility states to elements with more robust handling
      Object.entries(elements).forEach(([key, element]) => {
        if (!element) return;
        
        const shouldShow = currentState[key] === 'show';
        
        // Use a more specific approach to prevent interference
        if (shouldShow) {
          element.classList.remove('d-none');
        } else {
          element.classList.add('d-none');
        }
      });
    }

    disableUnavailableOptions() {
      const variants = this._getVariantData();
      const optionGroups = this.querySelectorAll('[data-optionindex]');
      
      // Cache DOM queries and selected values
      const selectedValues = {};
      const optionElements = {};
      
      // Get selected values for all options in one pass
      optionGroups.forEach(group => {
        const optionIndex = parseInt(group.dataset.optionindex);
        const checkedInput = group.querySelector('input[type="radio"]:checked');
        const selectElement = group.querySelector('select');
        
        selectedValues[optionIndex] = checkedInput?.value || selectElement?.value || null;
        optionElements[optionIndex] = group;

      });
      
      // Create lookup maps for faster variant checking
      const option1Variants = new Map();
      const option1Option2Variants = new Map();
      const option1Option3Variants = new Map();
      
      // Build lookup maps in one pass through variants
      variants.forEach(variant => {
        if (variant.option1) {
          // Map option1 -> all variants with that option1
          if (!option1Variants.has(variant.option1)) {
            option1Variants.set(variant.option1, []);
          }
          option1Variants.get(variant.option1).push(variant);
          
          // Map option1+option2 -> all variants with that combination
          if (variant.option2) {
            const key = `${variant.option1}|${variant.option2}`;
            if (!option1Option2Variants.has(key)) {
              option1Option2Variants.set(key, []);
            }
            option1Option2Variants.get(key).push(variant);
          }
          
          // Map option1+option3 -> all variants with that combination
          if (variant.option3) {
            const key = `${variant.option1}|${variant.option3}`;
            if (!option1Option3Variants.has(key)) {
              option1Option3Variants.set(key, []);
            }
            option1Option3Variants.get(key).push(variant);
          }
        }
      });
      
      // Process each option group
      optionGroups.forEach(group => {
        const optionIndex = parseInt(group.dataset.optionindex);
        const inputs = group.querySelectorAll('input[type="radio"], option');
        
        if (optionIndex === 1) {
          // Option1: always enable all values
          inputs.forEach(input => input.classList.remove('disabled'));
          return;
        }
        
        const selectedOption1 = selectedValues[1];
        if (!selectedOption1) {
          // If no option1 selected, disable all other options
          inputs.forEach(input => input.classList.add('disabled'));
          return;
        }
        
        // Get available values for this option
        const availableValues = [];
        const variantsWithOption1 = option1Variants.get(selectedOption1) || [];

        
        if (optionIndex === 2) {
          // Get unique option2 values available with selected option1 only
          const uniqueOption2Values = [...new Set(variantsWithOption1.map(v => v.option2).filter(Boolean))];
          availableValues.push(...uniqueOption2Values);
        } else if (optionIndex === 3) {
          // Get unique option3 values available with selected option1 and option2
          const selectedOption2 = selectedValues[2];
          let variantsToCheck = variantsWithOption1;
          
          if (selectedOption2) {
            // Filter variants that also have the selected option2
            variantsToCheck = variantsToCheck.filter(v => v.option2 === selectedOption2);
          }
          
          const uniqueOption3Values = [...new Set(variantsToCheck.map(v => v.option3).filter(Boolean))];
          availableValues.push(...uniqueOption3Values);
        }
        
        // Process option2 and option3
        let currentSelectionValid = false;
        const currentValue = selectedValues[optionIndex];
        
        inputs.forEach(input => {
          const value = input.value;
          const isValid = availableValues.includes(value);
          
          input.classList.toggle('disabled', !isValid);
          
          // Also toggle disabled attribute for select options
          if (input.tagName === 'OPTION') {
            input.disabled = !isValid;
          }
          
          // Check if current selection is still valid
          if (value === currentValue && isValid) {
            currentSelectionValid = true;
          }
        });
        
        // Auto-select first available option if current selection is invalid
        if (!currentSelectionValid && availableValues.length > 0) {
          const firstAvailableValue = availableValues[0];
          const firstAvailableInput = Array.from(inputs).find(input => 
            input.value === firstAvailableValue && !input.classList.contains('disabled')
          );
          
          if (firstAvailableInput) {
            if (firstAvailableInput.type === 'radio') {
              firstAvailableInput.checked = true;
              // Trigger change event on the radio input
              firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
            } else if (firstAvailableInput.tagName === 'OPTION') {
              firstAvailableInput.selected = true;
              // Trigger change event on the select element
              const selectElement = firstAvailableInput.closest('select');
              if (selectElement) {
                selectElement.dispatchEvent(new Event('change', { bubbles: true }));
              }
            }
            
            // Update the selectedValues cache
            selectedValues[optionIndex] = firstAvailableValue;
          }
        }
      });
    }

    /**
     * Trigger this function variant is changed
     */
    onVariantChange() {
      this.setCurrentVariant();
      if (this.formType === 'product-page' && this.currentVariant){
        globalSpace.product.currentVariant = this.currentVariant;
      }

      eventBus.publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          container: this.container,
          variant: this.currentVariant,
        },
      });

      this.updateOptionLabel(this.container);
      if(typeof this.formParent?.updateProductDetails == 'function'){
        this.formParent.updateProductDetails(this.container, this.currentVariant);
      }
      
      // Update quantity input with new variant's MOQ and step
      this.updateQuantityInput();
      
      // Handle wholesale visibility after all other updates to prevent interference
      this.handleWholesaleOnly();

      // if(this.formType === 'product-page') 
        this.disableUnavailableOptions();
    }

    // updateQuantityInput() {
    //   if (!this.currentVariant) return;
      
    //   const qtyInput = this.container.querySelector('[data-qty-input]');
    //   if (!qtyInput) return;

    //   const moq = this.currentVariant.metafields?.minimum_order_quantity || 1;
    //   const step = this.currentVariant.metafields?.order_quantity_step || moq;
    //   const currentValue = parseInt(qtyInput.value) || moq;
      
    //   // Update input attributes
    //   qtyInput.setAttribute('min', moq);
    //   qtyInput.setAttribute('step', step);
    //   qtyInput.setAttribute('data-custom-moq', moq);
      
    //   // Update value if current value is less than new MOQ
    //   // or not a valid multiple of the step
    //   if (currentValue < moq || (currentValue - moq) % step !== 0) {
    //     qtyInput.value = moq;
    //   }
      
    //   // Update decrease button state
    //   const decreaseBtn = this.container.querySelector('[data-for="decrease"]');
    //   if (decreaseBtn) {
    //     decreaseBtn.classList.toggle('disabled', currentValue <= moq);
    //   }
    // }

    updateQuantityInput() {
      if (!this.currentVariant) return;
      
      const qtyInput = this.container.querySelector('[data-qty-input]');
      if (!qtyInput) return;

      // Read MOQ from variant metafields, or fall back to existing data attribute, then to 1
      const moq = this.currentVariant.metafields?.minimum_order_quantity || 
                  parseInt(qtyInput.dataset.customMoq) || 
                  parseInt(qtyInput.getAttribute('min')) || 
                  1;
      const step = this.currentVariant.metafields?.order_quantity_step || 
                   parseInt(qtyInput.getAttribute('step')) || 
                   moq;
      const currentValue = parseInt(qtyInput.value) || moq;
      
      // Update input attributes
      qtyInput.setAttribute('min', moq);
      qtyInput.setAttribute('step', step);
      qtyInput.setAttribute('data-custom-moq', moq);
      
      // Only update value if current value is invalid (less than MOQ or not a multiple of step)
      if (currentValue < moq || (currentValue - moq) % step !== 0) {
        qtyInput.value = moq;
      }
      // If current value is valid, keep it as is (don't reset on variant change)
      
      // Update decrease button state
      const decreaseBtn = this.container.querySelector('[data-for="decrease"]');
      if (decreaseBtn) {
        decreaseBtn.classList.toggle('disabled', parseInt(qtyInput.value) <= moq);
      }
    }

    get selectedOptionValues() {
      const optionGroups = Array.from(this.querySelectorAll('[data-optionindex]'))
        .sort((a, b) => Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex));
    
      return optionGroups.map(group => {
        const select = group.querySelector('select');
        if (select) return select.value;
    
        const checkedRadio = group.querySelector('input[type="radio"]:checked');
        if (checkedRadio) return checkedRadio.value;
    
        return null; // fallback if no value selected
      });
    }

    /**
     * change value of currentVariant when variant being changed 
     */

    setCurrentVariant() {
      this.currentVariant = false;
      const options = this.selectedOptionValues;
      const variants = this._getVariantData();
      variants.find(variant => {
          const variantOptions = [variant.option1, variant.option2, variant.option3].filter(opt => opt !== null && opt !== undefined);
          if (variantOptions.every((option, i) => options[i] === option)) {
            this.currentVariant = variant;
          }
      });
    }
  
    /**
     * Update selected option name label
     */
    updateOptionLabel(form){
      form.querySelectorAll('[data-optionindex]').forEach(option => {
        const label = option.querySelector('.selected-option');
        if(label) label.textContent = this.currentVariant[`option${option.dataset.optionindex}`];
      });
    }

    /**
     * Store the all the variants json
     */
    _getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
      return this.variantData;
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }

    get optionValues() {
      // Fix: Get the actual selected <select> elements and checked radio inputs, not <option> elements
      return Array.from(this.querySelectorAll('select, fieldset input[type="radio"]:checked')).map(el => {
        if (el.tagName === 'SELECT') {
          // For <select>, get the selected option's dataset.optionValueId
          const selectedOption = el.selectedOptions[0];
          return selectedOption ? selectedOption.dataset.optionValueId : null;
        } else {
          // For checked radio input
          return el.dataset.optionValueId;
        }
      });
    }
}
customElements.define('variant-selects', VariantSelects);